import type { ReactElement, ReactNode } from 'react';
import React from 'react';

export type PlaceHolderProps = { placeholder?: ReactNode };

export default function NoDataPlaceholder({ placeholder }: PlaceHolderProps): ReactElement {
  return (
    <div className="no-results border text-center p-4">
      {placeholder || 'There is not yet sufficient data to generate a table'}
    </div>
  );
}
